import React, { useEffect, useState } from "react";
import AdminMenu from "./AdminMenu";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
import toast from "react-hot-toast";
import { server } from "../server";
import { IoCloseCircleSharp } from "react-icons/io5";

const CreateBrands = () => {
  const [name, setName] = useState("");
  const [imageUrl, setImageUrl] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const validateForm = () => {
    if (!name.trim()) {
      toast.error("Brand name is required");
      return false;
    }
    if (imageUrl.length === 0) {
      toast.error("Please upload Brand Image");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    try {
      setLoading(true);
      const carData = new FormData();
      carData.append("name", name);

      imageUrl.forEach((image, index) => {
        carData.append(`documents`, image);
      });
      const { data } = await axios.post(
        `${server}/api/brand/create-brand`,
        carData
      );

      if (data.success) {
        toast.success("Brand Created Successfully");
        navigate("/dashboard/admin/allbrands");
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const MAX_FILE_SIZE = 200 * 1024; // 200KB

  const handleRemoveImage = (index) => {
    const updatedImages = [...imageUrl];
    updatedImages.splice(index, 1);
    setImageUrl(updatedImages);
  };

  return (
    <div className="container marginStyle">
      {!loading ? (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <AdminMenu />
            </div>
            <div className="col-md-9 my-3">
              <form method="post" enctype="multipart/form-data">
                <h1 className="text-center">Create Brand</h1>
                <div className="m-1">
                  <div className="mb-3">
                    <input
                      type="text"
                      value={name}
                      placeholder="Enter the brand name"
                      className="form-control"
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>
                  {imageUrl.map((image, index) => (
                    <div
                      key={index}
                      className="text-center"
                      style={{ position: "relative", width: "100px" }}
                    >
                      <img
                        src={image}
                        alt={`car_image_${index}`}
                        className="img img-fluid"
                        style={{
                          maxWidth: "80px",
                          height: "auto",
                          borderRadius: "5px",
                          objectFit: "cover",
                        }}
                      />
                      <button
                        type="button"
                        className="remove-image-btn"
                        onClick={() => handleRemoveImage(index)}
                        style={{
                          border: "none",
                          backgroundColor: "none",
                          background: "none",
                          position: "absolute",
                          top: "-2px",
                          right: "10px",
                          color: "red",
                        }}
                      >
                        <IoCloseCircleSharp
                          size={20}
                          style={{ color: "green" }}
                        />
                      </button>
                    </div>
                  ))}

                  <div className="image-upload mb-3">
                    <label className="upload-label col-md-12">
                      Upload Image
                      <input
                        type="file"
                        name="productPictures"
                        accept="image/*"
                        multiple
                        onChange={(e) => {
                          let files = Array.from(e.target.files);
                          files.forEach((file) => {
                            const reader = new FileReader();
                            reader.onload = () => {
                              const image = new Image();
                              image.src = reader.result;
                              image.onload = () => {
                                const canvas = document.createElement("canvas");
                                const ctx = canvas.getContext("2d");

                                const MAX_WIDTH = 800; // Max width for the image
                                const MAX_HEIGHT = 600; // Max height for the image

                                let width = image.width;
                                let height = image.height;

                                // Resize the image if it exceeds the max width or height
                                if (width > MAX_WIDTH || height > MAX_HEIGHT) {
                                  const aspectRatio = width / height;
                                  if (width > height) {
                                    width = MAX_WIDTH;
                                    height = width / aspectRatio;
                                  } else {
                                    height = MAX_HEIGHT;
                                    width = height * aspectRatio;
                                  }
                                }

                                canvas.width = width;
                                canvas.height = height;

                                ctx.drawImage(image, 0, 0, width, height);

                                canvas.toBlob(
                                  (blob) => {
                                    if (blob.size <= MAX_FILE_SIZE) {
                                      setImageUrl((old) => [
                                        ...old,
                                        canvas.toDataURL(),
                                      ]);
                                    } else {
                                      console.log("Image size exceeds 200KB");
                                    }
                                  },
                                  "image/jpeg",
                                  0.6
                                ); // 0.6 is the image quality (adjust as needed)
                              };
                            };
                            reader.readAsDataURL(file);
                          });
                        }}
                        hidden
                      />
                    </label>
                  </div>
                  <div className="mb-3">
                    <button className="btn btn-success" onClick={handleSubmit}>
                      Create Brand
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default CreateBrands;
